<template>
  <div class="modal-dim on">
    <!--'on 추가'-->
    <div class="modal-wrap">
      <div class="modal-inner bottom">
        <div class="modal">
          <div class="modal-head">
            <h1>{{ title }}</h1>
          </div>
          <div class="modal-delete">
            <i class="i-modal-delete"></i>
          </div>

          <div class="modal-con check">
            <div class="modal-txt">
              <ul class="check-ul">
                <li class="form-li" v-for="item in timeOption" :key="item.value">
                  <div class="radio-box">
                    <label class="radio">
                      <input type="radio" name="radio" :value="item.value" v-model="form.duration" />
                      <span class="radio-txt">{{ item.label }}</span>
                    </label>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="modal-btn">
            <div class="btn-wrap">
              <button class="btn yd-cta yd-cta--secondary" @click="cancel">{{ rejectText }}</button>
              <button class="btn yd-cta yd-cta--primary" @click="confirm">{{ confirmText }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, defineEmits, defineProps, ref, toRefs } from 'vue';
import { cloneDeep } from 'lodash';
import Util from '@/common/utils/Util';
import store from '@/store';

const { translator } = Util;

const { data } = defineProps(['data']);
const emits = defineEmits(['close']);

const { title = '', confirmText = '', rejectText = '' } = toRefs(data);
const form = ref(data.form);
const timeOption = computed(() => {
  const constants = Object.values(store.getters['constant/getConstant'][['TIME_SPEND']]);
  return constants.map((elem) => {
    return {
      label: translator(elem),
      value: elem.key
    };
  });
});

const cancel = () => emits('close');
const confirm = () => {
  const { duration } = form.value;
  if (!duration) return;

  const cloneData = cloneDeep(form.value);

  const payload = {
    orderNo: cloneData.order.orderNo,
    orderState: cloneData.orderState,
    orderType: cloneData.order.orderType,
    duration: duration,
    orderManageNo: cloneData.order.orderManageNo,
    storeUserNo: cloneData.storeUserNo,
    userNo: cloneData.order.userNo,
    nameKr: cloneData.store.nameKr,
    nameVn: cloneData.store.nameVn,
    nameEn: cloneData.store.nameEn
  };

  store.dispatch('admin_order/CHANGE_ORDER_STATE', payload);
  cancel();
};
</script>

<style scoped></style>
/* *Created on 2023-10-27 *ProjectName user */
